import PatientOverviewHNProgressGeneral from 'dashboard/templates/views/Patient/HN/PatientOverviewHNProgressGeneral';
import RouteRequirements from "../../../../../../../../model/RouteRequirements";

export const routeRequirements = (new RouteRequirements())
    .setEnabledModules(['HEALTHYNUTRITION']);

export default {
    path: 'general',
    name: 'PatientOverviewHNProgressGeneral',
    component: PatientOverviewHNProgressGeneral,
    meta: {
        // title: 'Patient Record - Healthy Nutrition - Progress - General',
        // title: t => `${t('patient.patientRecord')} - ${t('screens.healthyNutritionSettingsScreen', 'app_mobile')} - ${t('journeyProgress.progress')} - ${t('general')}`,
        // title: 'Healthy Nutrition - Status',
        title: t => `${t('screens.healthyNutritionSettingsScreen', 'app_mobile')} - ${t('journeyBehaviourChangeGoals.status')}`,
        routeRequirements
    },
};